import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";
import React from "react";

const timeResetOptions = (type) => {
  return type === "end"
    ? {
        hour: 23,
        minute: 59,
        second: 59,
      }
    : {
        hour: 0,
        minute: 0,
        second: 0,
      };
};

const EpochFields = () => {
  const DateTimeField = ({ field, form, variant, inputVariant, ...props }) => {
    const handleChange = (date) => {
      const formattedDate = date
        ? date.isValid()
          ? date.format()
          : date._i
        : null;

      form.setFieldValue(field.name, formattedDate);
    };

    return (
      <KeyboardDateTimePicker
        {...field}
        {...props}
        format="DD/MM/yyyy HH:mm"
        ampm={false}
        invalidDateMessage={null}
        variant={variant || "inline"}
        inputVariant={inputVariant || "outlined"}
        onChange={handleChange}
        autoOk
        disableToolbar
      />
    );
  };

  const DateField = ({
    field,
    form,
    variant,
    inputVariant,
    resetTime,
    ...props
  }) => {
    const handleChange = (date) => {
      const formattedDate = date
        ? date.isValid()
          ? date.set(timeResetOptions(resetTime)).format()
          : date._i
        : null;

      form.setFieldValue(field.name, formattedDate);
    };

    return (
      <KeyboardDatePicker
        {...field}
        {...props}
        KeyboardButtonProps={{ style: { paddingRight: "0px" } }}
        format="DD/MM/yyyy"
        variant={variant || "inline"}
        invalidDateMessage={null}
        inputVariant={inputVariant || "outlined"}
        onChange={handleChange}
        autoOk
        disableToolbar
      />
    );
  };

  return { DateTimeField, DateField };
};

export const { DateTimeField, DateField } = EpochFields();
